'use client'
import { AnimatePresence, domAnimation, LazyMotion, m as motion, useInView } from 'framer-motion'

import { FC, useRef } from 'react'

import { IChildren, IClassName } from '@/app/shared/interfaces/common.interface'

// interface
interface IShowText extends IChildren, IClassName {}

// component
const ShowTextComponent: FC<Readonly<IShowText>> = ({ children, className }) => {
  const parentEl = useRef(null)

  const isInView = useInView(parentEl, { once: true, amount: 0.5 })

  // return
  return (
    <p className={className} ref={parentEl}>
      <LazyMotion features={domAnimation}>
        <AnimatePresence>
          {(children as string)?.split(' ')?.map((word, index) => (
            <motion.span
              key={index}
              transition={{
                staggerChildren: 0.1,
              }}
              className={'mr-4 inline-flex'}
            >
              {word?.split('')?.map((char, indexSecond) => (
                <motion.span
                  key={indexSecond}
                  initial={{ opacity: 0, y: 20 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ delay: index * 0.2 + indexSecond * 0.05, duration: 0.5 }}
                  style={{
                    display: 'inline-block',
                  }}
                  className={'mr-[0.4px]'}
                >
                  {char}
                </motion.span>
              ))}
            </motion.span>
          ))}
        </AnimatePresence>
      </LazyMotion>
    </p>
  )
}

export default ShowTextComponent
